import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icssr-funded-minor-project',
  templateUrl: './icssr-funded-minor-project.component.html',
  styleUrls: ['./icssr-funded-minor-project.component.scss']
})
export class IcssrFundedMinorProjectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
